import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "customer-navbar" }
const _hoisted_2 = { class: "navbar-inner" }
const _hoisted_3 = { class: "navbar-left" }
const _hoisted_4 = { class: "navbar-logo" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "brand-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "back-btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('back')))
        }, [
          _createVNode($setup["ArrowLeft"], { size: 20 }),
          _cache[2] || (_cache[2] = _createElementVNode("span", null, "Back", -1))
        ]),
        ($props.showMap)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "nav-btn",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('mapClick')))
            }, [
              _createVNode($setup["Map"], { size: 20 }),
              _cache[3] || (_cache[3] = _createElementVNode("span", null, "View Map", -1))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        ($props.logoUrl)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "logo-img",
              src: $props.logoUrl,
              alt: "Logo"
            }, null, 8, _hoisted_5))
          : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString($props.brandText), 1))
      ]),
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "navbar-right" }, null, -1))
    ])
  ]))
}